import { useParams } from "react-router-dom";
import SingleProduct from "../components/SingleProduct/SingleProduct";

export default function SingleView({
  cart,
  setCart,
  showMessage,
  setShowMessage,
  showAllId,
  setShowAllId,
  setActive
}) {
  const { productId } = useParams();
  return (
    <>
      <SingleProduct
        id={productId}
        cart={cart}
        setCart={setCart}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
        showAllId={showAllId}
        setShowAllId={setShowAllId}
        setActive={setActive}
      ></SingleProduct>
    </>
  );
}
